import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
export const addArticle = async (data) => {
  try {
    const res = await request.post(Constants.add_activationstep_api_url, data);
    if (res) {
      return res;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
export const getActivationSteps = async () => {
  try {
    const res = await request.get(Constants.get_activationstep_api_url);
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const deleteActivationSteps = async (id) => {
  try {
    const res = await request.delete(
      `${Constants.delete_activationstep_api_url}/${id}`
    );
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const getSpecificActivationStep = async (id) => {
  try {
    const res = await request.get(
      `${Constants.get_specific_activationstep_api_url}/${id}`
    );
    if (res) {
      return res;
    }
  } catch (e) {
    throw e;
  }
};
export const editArticle = async (data, id) => {
  try {
    const res = await request.put(
      `${Constants.add_activationstep_api_url}/${id}`,
      data
    );
    if (res) {
      return res;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
